import React from "react";
import { TECHINCAL_SPECIFICATION_IMG } from "../config/Constant";
import { Container, Grid, SecTitle, WhyUsSection } from "./AboutWhyLuton";
import { AboutPageLang } from "../lang/AboutPageLang";
import MainImgBlock from "../pages/MainImgBlock";
import { motion } from "framer-motion";
import styled from "styled-components";

// Animation variants
const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const zoomIn = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } },
};

// Styled title
const StyledSecTitle = styled(SecTitle)`
  h3 {
    font-size: 42px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 2px;
    background: linear-gradient(90deg, #ffcc00, #ff8800);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    &:after {
      content: "";
      display: block;
      height: 4px;
      width: 80px;
      background: #ffcc00;
      margin: 12px auto 0;
      border-radius: 2px;
      transition: width 0.4s ease;
    }

    &:hover:after {
      width: 140px;
    }

    @media (max-width: 1024px) {
      font-size: 36px;
    }

    @media (max-width: 768px) {
      font-size: 30px;
    }

    @media (max-width: 480px) {
      font-size: 26px;
    }
  }
`;

// Styled image wrapper
const ImageWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 16px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.25);
    transition: transform 0.6s ease, filter 0.6s ease;

    &:hover {
      transform: scale(1.05);
      filter: brightness(1.1) contrast(1.05);
    }
  }
`;

const TechnicalSpecification = () => {
  return (
    <>
      {/* Hero Banner */}
      <MainImgBlock
        title={AboutPageLang.TECHNICAL_SPECIFICATION}
        imgLink={"/exportNetwork/support.webp"}
      />

      {/* Specification Section */}
      <WhyUsSection>
        <Container>
          {/* Animated Section Title */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            variants={fadeUp}
          >
            <StyledSecTitle>
              <h3>{AboutPageLang.TECHNICAL_SPECIFICATION}</h3>
            </StyledSecTitle>
          </motion.div>

          {/* Animated Image */}
          <Grid>
            <ImageWrapper
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }}
              variants={zoomIn}
            >
              <img
                src={TECHINCAL_SPECIFICATION_IMG}
                alt="Technical Specification"
                loading="lazy"
              />
            </ImageWrapper>
          </Grid>
        </Container>
      </WhyUsSection>
    </>
  );
};

export default TechnicalSpecification;
